import SweetAlert from "react-bootstrap-sweetalert";

const Confirmation = (props: any) => {

  return <SweetAlert
    title="Warning"
    warning
    showCancel
    confirmBtnBsStyle="danger"
    confirmBtnCssClass="me-2"
    cancelBtnBsStyle="secondary"
    cancelBtnCssClass="ms-2"
    btnSize="default"
    reverseButtons={true}
    {...props}>
    {props.children}
  </SweetAlert>
}

export default Confirmation;